export const municipaliteis = [
  { value: "Abercorn", label: "Abercorn" },
  { value: "Abitibi", label: "Abitibi" },
  { value: "Abitibi-Ouest", label: "Abitibi-Ouest" },
  { value: "Acton", label: "Acton" },
  { value: "Acton Vale", label: "Acton Vale" },
  { value: "Adstock", label: "Adstock" },
  { value: "Aguanish", label: "Aguanish" },
  { value: "Akulivik", label: "Akulivik" },
  { value: "Albanel", label: "Albanel" },
  { value: "Albertville", label: "Albertville" },
  { value: "Alleyn-et-Cawood", label: "Alleyn-et-Cawood" },
  { value: "Alma", label: "Alma" },
  { value: "Amherst", label: "Amherst" },
  { value: "Amos", label: "Amos" },
  { value: "Amqui", label: "Amqui" },
  { value: "Ange-Gardien", label: "Ange-Gardien" },
  { value: "Antoine-Labelle", label: "Antoine-Labelle" },
  { value: "Argenteuil", label: "Argenteuil" },
  { value: "Armagh", label: "Armagh" },
  { value: "Arthabaska", label: "Arthabaska" },
  { value: "Arundel", label: "Arundel" },
  { value: "Asbestos", label: "Asbestos" },
  { value: "Ascot Corner", label: "Ascot Corner" },
  { value: "Aston-Jonction", label: "Aston-Jonction" },
  { value: "Auclair", label: "Auclair" },
  { value: "Audet", label: "Audet" },
  { value: "Aumond", label: "Aumond" },
  { value: "Aupaluk", label: "Aupaluk" },
  { value: "Austin", label: "Austin" },
  { value: "Authier", label: "Authier" },
  { value: "Authier-Nord", label: "Authier-Nord" },
  { value: "Avignon", label: "Avignon" },
  { value: "Ayer's Cliff", label: "Ayer's Cliff" },
  { value: "Baie-Comeau", label: "Baie-Comeau" },
  { value: "Baie-des-Sables", label: "Baie-des-Sables" },
  { value: "Baie-du-Febvre", label: "Baie-du-Febvre" },
  { value: "Baie-D'Urfé", label: "Baie-D'Urfé" },
  { value: "Baie-Johan-Beetz", label: "Baie-Johan-Beetz" },
  { value: "Baie-Sainte-Catherine", label: "Baie-Sainte-Catherine" },
  { value: "Baie-Saint-Paul", label: "Baie-Saint-Paul" },
  { value: "Baie-Trinité", label: "Baie-Trinité" },
  { value: "Barkmere", label: "Barkmere" },
  { value: "Barnston-Ouest", label: "Barnston-Ouest" },
  { value: "Barraute", label: "Barraute" },
  { value: "Batiscan", label: "Batiscan" },
  { value: "Beaconsfield", label: "Beaconsfield" },
  { value: "Béarn", label: "Béarn" },
  { value: "Beauce-Sartigan", label: "Beauce-Sartigan" },
  { value: "Beauceville", label: "Beauceville" },
  { value: "Beauharnois", label: "Beauharnois" },
  { value: "Beauharnois-Salaberry", label: "Beauharnois-Salaberry" },
  { value: "Beaulac-Garthby", label: "Beaulac-Garthby" },
  { value: "Beaumont", label: "Beaumont" },
  { value: "Beaupré", label: "Beaupré" },
  { value: "Bécancour", label: "Bécancour" },
  { value: "Bedford", label: "Bedford" },
  { value: "Bégin", label: "Bégin" },
  { value: "Belcourt", label: "Belcourt" },
  { value: "Bellechasse", label: "Bellechasse" },
  { value: "Belleterre", label: "Belleterre" },
  { value: "Beloeil", label: "Beloeil" },
  { value: "Berry", label: "Berry" },
  { value: "Berthier-sur-Mer", label: "Berthier-sur-Mer" },
  { value: "Berthierville", label: "Berthierville" },
  { value: "Béthanie", label: "Béthanie" },
  { value: "Biencourt", label: "Biencourt" },
  { value: "Blainville", label: "Blainville" },
  { value: "Blanc-Sablon", label: "Blanc-Sablon" },
  { value: "Blue Sea", label: "Blue Sea" },
  { value: "Boileau", label: "Boileau" },
  { value: "Boisbriand", label: "Boisbriand" },
  { value: "Boischatel", label: "Boischatel" },
  { value: "Bois-des-Filion", label: "Bois-des-Filion" },
  { value: "Bois-Franc", label: "Bois-Franc" },
  { value: "Bolton-Est", label: "Bolton-Est" },
  { value: "Bolton-Ouest", label: "Bolton-Ouest" },
  { value: "Bonaventure", label: "Bonaventure" },
  { value: "Bonne-Espérance", label: "Bonne-Espérance" },
  { value: "Bonsecours", label: "Bonsecours" },
  { value: "Boucherville", label: "Boucherville" },
  { value: "Bouchette", label: "Bouchette" },
  { value: "Bowman", label: "Bowman" },
  { value: "Brébeuf", label: "Brébeuf" },
  { value: "Brigham", label: "Brigham" },
  { value: "Bristol", label: "Bristol" },
  { value: "Brome", label: "Brome" },
  { value: "Brome-Missisquoi", label: "Brome-Missisquoi" },
  { value: "Bromont", label: "Bromont" },
  { value: "Brossard", label: "Brossard" },
  { value: "Brownsburg-Chatham", label: "Brownsburg-Chatham" },
  { value: "Bryson", label: "Bryson" },
  { value: "Bury", label: "Bury" },
  { value: "Cacouna", label: "Cacouna" },
  { value: "Calixa-Lavallée", label: "Calixa-Lavallée" },
  { value: "Campbell's Bay", label: "Campbell's Bay" },
  { value: "Candiac", label: "Candiac" },
  { value: "Caniapiscau", label: "Caniapiscau" },
  { value: "Cantley", label: "Cantley" },
  { value: "Cap-Chat", label: "Cap-Chat" },
  { value: "Caplan", label: "Caplan" },
  { value: "Cap-Saint-Ignace", label: "Cap-Saint-Ignace" },
  { value: "Cap-Santé", label: "Cap-Santé" },
  { value: "Carignan", label: "Carignan" },
  { value: "Carleton-sur-Mer", label: "Carleton-sur-Mer" },
  { value: "Cascapédia--Saint-Jules", label: "Cascapédia--Saint-Jules" },
  { value: "Causapscal", label: "Causapscal" },
  { value: "Cayamant", label: "Cayamant" },
  { value: "Chambly", label: "Chambly" },
  { value: "Chambord", label: "Chambord" },
  { value: "Champlain", label: "Champlain" },
  { value: "Champneuf", label: "Champneuf" },
  { value: "Chandler", label: "Chandler" },
  { value: "Chapais", label: "Chapais" },
  { value: "Charette", label: "Charette" },
  { value: "Charlemagne", label: "Charlemagne" },
  { value: "Charlevoix", label: "Charlevoix" },
  { value: "Charlevoix-Est", label: "Charlevoix-Est" },
  { value: "Chartierville", label: "Chartierville" },
  { value: "Châteauguay", label: "Châteauguay" },
  { value: "Château-Richer", label: "Château-Richer" },
  { value: "Chazel", label: "Chazel" },
  { value: "Chelsea", label: "Chelsea" },
  { value: "Chénéville", label: "Chénéville" },
  { value: "Chertsey", label: "Chertsey" },
  { value: "Chesterville", label: "Chesterville" },
  { value: "Chibougamau", label: "Chibougamau" },
  { value: "Chichester", label: "Chichester" },
  { value: "Chisasibi", label: "Chisasibi" },
  { value: "Chute-aux-Outardes", label: "Chute-aux-Outardes" },
  { value: "Chute-Saint-Philippe", label: "Chute-Saint-Philippe" },
  { value: "Clarendon", label: "Clarendon" },
  { value: "Clermont", label: "Clermont" },
  { value: "Clerval", label: "Clerval" },
  { value: "Cleveland", label: "Cleveland" },
  { value: "Cloridorme", label: "Cloridorme" },
  { value: "Coaticook", label: "Coaticook" },
  { value: "Colombier", label: "Colombier" },
  { value: "Compton", label: "Compton" },
  { value: "Contrecœur", label: "Contrecœur" },
  { value: "Cookshire-Eaton", label: "Cookshire-Eaton" },
  { value: "Coteau-du-Lac", label: "Coteau-du-Lac" },
  {
    value: "Côte-Nord-du-Golfe-du-Saint-Laurent",
    label: "Côte-Nord-du-Golfe-du-Saint-Laurent",
  },
  { value: "Côte-Saint-Luc", label: "Côte-Saint-Luc" },
  { value: "Courcelles", label: "Courcelles" },
  { value: "Cowansville", label: "Cowansville" },
  { value: "Crabtree", label: "Crabtree" },
  { value: "Danville", label: "Danville" },
  { value: "D'Autray", label: "D'Autray" },
  { value: "Daveluyville", label: "Daveluyville" },
  { value: "Dégelis", label: "Dégelis" },
  { value: "Déléage", label: "Déléage" },
  { value: "Delson", label: "Delson" },
  { value: "Denholm", label: "Denholm" },
  { value: "Desbiens", label: "Desbiens" },
  {
    value: "Deschaillons-sur-Saint-Laurent",
    label: "Deschaillons-sur-Saint-Laurent",
  },
  { value: "Deschambault-Grondines", label: "Deschambault-Grondines" },
  { value: "Deux-Montagnes", label: "Deux-Montagnes" },
  { value: "Disraeli", label: "Disraeli" },
  { value: "Dixville", label: "Dixville" },
  { value: "Dolbeau-Mistassini", label: "Dolbeau-Mistassini" },
  { value: "Dollard-Des Ormeaux", label: "Dollard-Des Ormeaux" },
  { value: "Donnacona", label: "Donnacona" },
  { value: "Dorval", label: "Dorval" },
  { value: "Dosquet", label: "Dosquet" },
  { value: "Drummond", label: "Drummond" },
  { value: "Drummondville", label: "Drummondville" },
  { value: "Dudswell", label: "Dudswell" },
  { value: "Duhamel", label: "Duhamel" },
  { value: "Duhamel-Ouest", label: "Duhamel-Ouest" },
  { value: "Dundee", label: "Dundee" },
  { value: "Dunham", label: "Dunham" },
  { value: "Duparquet", label: "Duparquet" },
  { value: "Dupuy", label: "Dupuy" },
  { value: "Durham-Sud", label: "Durham-Sud" },
  { value: "East Angus", label: "East Angus" },
  { value: "East Broughton", label: "East Broughton" },
  { value: "East Farnham", label: "East Farnham" },
  { value: "East Hereford", label: "East Hereford" },
  { value: "Eastmain", label: "Eastmain" },
  { value: "Eastman", label: "Eastman" },
  { value: "Egan-Sud", label: "Egan-Sud" },
  { value: "Elgin", label: "Elgin" },
  { value: "Entrelacs", label: "Entrelacs" },
  { value: "Escuminac", label: "Escuminac" },
  { value: "Esprit-Saint", label: "Esprit-Saint" },
  { value: "Estérel", label: "Estérel" },
  { value: "Farnham", label: "Farnham" },
  { value: "Fassett", label: "Fassett" },
  { value: "Ferland-et-Boilleau", label: "Ferland-et-Boilleau" },
  { value: "Ferme-Neuve", label: "Ferme-Neuve" },
  { value: "Fermont", label: "Fermont" },
  { value: "Forestville", label: "Forestville" },
  { value: "Fort-Coulonge", label: "Fort-Coulonge" },
  { value: "Fortierville", label: "Fortierville" },
  { value: "Fossambault-sur-le-Lac", label: "Fossambault-sur-le-Lac" },
  { value: "Frampton", label: "Frampton" },
  { value: "Franklin", label: "Franklin" },
  { value: "Franquelin", label: "Franquelin" },
  { value: "Frelighsburg", label: "Frelighsburg" },
  { value: "Frontenac", label: "Frontenac" },
  { value: "Fugèreville", label: "Fugèreville" },
  { value: "Gallichan", label: "Gallichan" },
  { value: "Gaspé", label: "Gaspé" },
  { value: "Gatineau", label: "Gatineau" },
  { value: "Girardville", label: "Girardville" },
  { value: "Godbout", label: "Godbout" },
  { value: "Godmanchester", label: "Godmanchester" },
  {
    value: "Gouvernement régional d'Eeyou Istchee Baie-James",
    label: "Gouvernement régional d'Eeyou Istchee Baie-James",
  },
  { value: "Gore", label: "Gore" },
  { value: "Gracefield", label: "Gracefield" },
  { value: "Granby", label: "Granby" },
  { value: "Grande-Rivière", label: "Grande-Rivière" },
  { value: "Grandes-Piles", label: "Grandes-Piles" },
  { value: "Grande-Vallée", label: "Grande-Vallée" },
  { value: "Grand-Métis", label: "Grand-Métis" },
  { value: "Grand-Remous", label: "Grand-Remous" },
  { value: "Grand-Saint-Esprit", label: "Grand-Saint-Esprit" },
  { value: "Grenville", label: "Grenville" },
  { value: "Grenville-sur-la-Rouge", label: "Grenville-sur-la-Rouge" },
  { value: "Gros-Mécatina", label: "Gros-Mécatina" },
  { value: "Grosse-Île", label: "Grosse-Île" },
  { value: "Grosses-Roches", label: "Grosses-Roches" },
  { value: "Guérin", label: "Guérin" },
  { value: "Ham-Nord", label: "Ham-Nord" },
  { value: "Ham-Sud", label: "Ham-Sud" },
  { value: "Hampden", label: "Hampden" },
  { value: "Hampstead", label: "Hampstead" },
  { value: "Harrington", label: "Harrington" },
  { value: "Hatley", label: "Hatley" },
  { value: "Havelock", label: "Havelock" },
  { value: "Havre-Saint-Pierre", label: "Havre-Saint-Pierre" },
  { value: "Hébertville", label: "Hébertville" },
  { value: "Hébertville-Station", label: "Hébertville-Station" },
  { value: "Hemmingford", label: "Hemmingford" },
  { value: "Henryville", label: "Henryville" },
  { value: "Hérouxville", label: "Hérouxville" },
  { value: "Hinchinbrooke", label: "Hinchinbrooke" },
  { value: "Honfleur", label: "Honfleur" },
  { value: "Hope", label: "Hope" },
  { value: "Hope Town", label: "Hope Town" },
  { value: "Howick", label: "Howick" },
  { value: "Huberdeau", label: "Huberdeau" },
  { value: "Hudson", label: "Hudson" },
  { value: "Huntingdon", label: "Huntingdon" },
  { value: "Inukjuak", label: "Inukjuak" },
  { value: "Inverness", label: "Inverness" },
  { value: "Irlande", label: "Irlande" },
  { value: "Ivry-sur-le-Lac", label: "Ivry-sur-le-Lac" },
  { value: "Ivujivik", label: "Ivujivik" },
  { value: "Joliette", label: "Joliette" },
  { value: "Kamouraska", label: "Kamouraska" },
  { value: "Kangiqsualujjuaq", label: "Kangiqsualujjuaq" },
  { value: "Kangiqsujuaq", label: "Kangiqsujuaq" },
  { value: "Kangirsuk", label: "Kangirsuk" },
  { value: "Kawawachikamach", label: "Kawawachikamach" },
  { value: "Kazabazua", label: "Kazabazua" },
  { value: "Kiamika", label: "Kiamika" },
  { value: "Kingsbury", label: "Kingsbury" },
  { value: "Kingsey Falls", label: "Kingsey Falls" },
  { value: "Kinnear's Mills", label: "Kinnear's Mills" },
  { value: "Kipawa", label: "Kipawa" },
  { value: "Kirkland", label: "Kirkland" },
  { value: "Kuujjuaq", label: "Kuujjuaq" },
  { value: "Kuujjuarapik", label: "Kuujjuarapik" },
  { value: "La Bostonnais", label: "La Bostonnais" },
  { value: "La Conception", label: "La Conception" },
  { value: "La Corne", label: "La Corne" },
  { value: "La Côte-de-Beaupré", label: "La Côte-de-Beaupré" },
  { value: "La Côte-de-Gaspé", label: "La Côte-de-Gaspé" },
  { value: "La Doré", label: "La Doré" },
  { value: "La Durantaye", label: "La Durantaye" },
  { value: "La Guadeloupe", label: "La Guadeloupe" },
  { value: "La Haute-Côte-Nord", label: "La Haute-Côte-Nord" },
  { value: "La Haute-Gaspésie", label: "La Haute-Gaspésie" },
  { value: "La Haute-Yamaska", label: "La Haute-Yamaska" },
  { value: "La Jacques-Cartier", label: "La Jacques-Cartier" },
  { value: "La Macaza", label: "La Macaza" },
  { value: "La Malbaie", label: "La Malbaie" },
  { value: "La Martre", label: "La Martre" },
  { value: "La Matanie", label: "La Matanie" },
  { value: "La Matapédia", label: "La Matapédia" },
  { value: "La Minerve", label: "La Minerve" },
  { value: "La Mitis", label: "La Mitis" },
  { value: "La Morandière", label: "La Morandière" },
  { value: "La Motte", label: "La Motte" },
  { value: "La Nouvelle-Beauce", label: "La Nouvelle-Beauce" },
  { value: "La Patrie", label: "La Patrie" },
  { value: "La Pêche", label: "La Pêche" },
  { value: "La Pocatière", label: "La Pocatière" },
  { value: "La Prairie", label: "La Prairie" },
  { value: "La Présentation", label: "La Présentation" },
  { value: "La Rédemption", label: "La Rédemption" },
  { value: "La Reine", label: "La Reine" },
  { value: "La Rivière-du-Nord", label: "La Rivière-du-Nord" },
  { value: "La Sarre", label: "La Sarre" },
  { value: "La Trinité-des-Monts", label: "La Trinité-des-Monts" },
  { value: "La Tuque", label: "La Tuque" },
  {
    value: "La Visitation-de-l'Île-Dupas",
    label: "La Visitation-de-l'Île-Dupas",
  },
  { value: "La Visitation-de-Yamaska", label: "La Visitation-de-Yamaska" },
  { value: "Labelle", label: "Labelle" },
  { value: "Labrecque", label: "Labrecque" },
  { value: "Lac-au-Saumon", label: "Lac-au-Saumon" },
  { value: "Lac-aux-Sables", label: "Lac-aux-Sables" },
  { value: "Lac-Beauport", label: "Lac-Beauport" },
  { value: "Lac-Bouchette", label: "Lac-Bouchette" },
  { value: "Lac-Brome", label: "Lac-Brome" },
  { value: "Lac-Delage", label: "Lac-Delage" },
  { value: "Lac-des-Aigles", label: "Lac-des-Aigles" },
  { value: "Lac-des-Écorces", label: "Lac-des-Écorces" },
  { value: "Lac-des-Plages", label: "Lac-des-Plages" },
  { value: "Lac-des-Seize-Îles", label: "Lac-des-Seize-Îles" },
  { value: "Lac-Drolet", label: "Lac-Drolet" },
  { value: "Lac-du-Cerf", label: "Lac-du-Cerf" },
  { value: "Lac-Édouard", label: "Lac-Édouard" },
  { value: "Lac-Etchemin", label: "Lac-Etchemin" },
  { value: "Lac-Frontière", label: "Lac-Frontière" },
  { value: "Lachute", label: "Lachute" },
  { value: "Lac-Mégantic", label: "Lac-Mégantic" },
  { value: "Lacolle", label: "Lacolle" },
  { value: "Lac-Poulin", label: "Lac-Poulin" },
  { value: "Lac-Saguay", label: "Lac-Saguay" },
  { value: "Lac-Sainte-Marie", label: "Lac-Sainte-Marie" },
  { value: "Lac-Saint-Jean-Est", label: "Lac-Saint-Jean-Est" },
  { value: "Lac-Saint-Joseph", label: "Lac-Saint-Joseph" },
  { value: "Lac-Saint-Paul", label: "Lac-Saint-Paul" },
  { value: "Lac-Sergent", label: "Lac-Sergent" },
  { value: "Lac-Simon", label: "Lac-Simon" },
  { value: "Lac-Supérieur", label: "Lac-Supérieur" },
  { value: "Lac-Tremblant-Nord", label: "Lac-Tremblant-Nord" },
  { value: "Laforce", label: "Laforce" },
  { value: "Lamarche", label: "Lamarche" },
  { value: "Lambton", label: "Lambton" },
  { value: "L'Ancienne-Lorette", label: "L'Ancienne-Lorette" },
  { value: "Landrienne", label: "Landrienne" },
  { value: "L'Ange-Gardien", label: "L'Ange-Gardien" },
  { value: "Lanoraie", label: "Lanoraie" },
  { value: "L'Anse-Saint-Jean", label: "L'Anse-Saint-Jean" },
  { value: "Lantier", label: "Lantier" },
  { value: "Larouche", label: "Larouche" },
  { value: "L'Ascension", label: "L'Ascension" },
  {
    value: "L'Ascension-de-Notre-Seigneur",
    label: "L'Ascension-de-Notre-Seigneur",
  },
  { value: "L'Ascension-de-Patapédia", label: "L'Ascension-de-Patapédia" },
  { value: "L'Assomption", label: "L'Assomption" },
  { value: "Latulipe-et-Gaboury", label: "Latulipe-et-Gaboury" },
  { value: "Launay", label: "Launay" },
  { value: "Laurier-Station", label: "Laurier-Station" },
  { value: "Laurierville", label: "Laurierville" },
  { value: "Laval", label: "Laval" },
  { value: "Lavaltrie", label: "Lavaltrie" },
  { value: "Laverlochère", label: "Laverlochère" },
  { value: "L'Avenir", label: "L'Avenir" },
  { value: "Lawrenceville", label: "Lawrenceville" },
  { value: "Lebel-sur-Quévillon", label: "Lebel-sur-Quévillon" },
  { value: "Leclerc", label: "Leclerc" },
  { value: "Lejeune", label: "Lejeune" },
  { value: "Lemieux", label: "Lemieux" },
  { value: "Léry", label: "Léry" },
  { value: "Les Bergeronnes", label: "Les Bergeronnes" },
  { value: "Les Cèdres", label: "Les Cèdres" },
  {
    value: "Les Collines-de-l'Outaouais",
    label: "Les Collines-de-l'Outaouais",
  },
  { value: "Les Coteaux", label: "Les Coteaux" },
  { value: "Les Éboulements", label: "Les Éboulements" },
  { value: "Les Escoumins", label: "Les Escoumins" },
  { value: "Les Etchemins", label: "Les Etchemins" },
  { value: "Les Hauteurs", label: "Les Hauteurs" },
  { value: "Les Îles-de-la-Madeleine", label: "Les Îles-de-la-Madeleine" },
  { value: "Les Jardins-de-Napierville", label: "Les Jardins-de-Napierville" },
  { value: "Les Laurentides", label: "Les Laurentides" },
  { value: "Les Maskoutains", label: "Les Maskoutains" },
  { value: "Les Méchins", label: "Les Méchins" },
  { value: "Les Moulins", label: "Les Moulins" },
  { value: "Les Pays-d'en-Haut", label: "Les Pays-d'en-Haut" },
  { value: "Les Sources", label: "Les Sources" },
  { value: "L'Érable", label: "L'Érable" },
  { value: "L'Épiphanie", label: "L'Épiphanie" },
  { value: "Lévis", label: "Lévis" },
  { value: "L'Île-Cadieux", label: "L'Île-Cadieux" },
  { value: "L'Île-d'Anticosti", label: "L'Île-d'Anticosti" },
  { value: "L'Île-Dorval", label: "L'Île-Dorval" },
  { value: "L'Île-d'Orléans", label: "L'Île-d'Orléans" },
  { value: "L'Île-du-Grand-Calumet", label: "L'Île-du-Grand-Calumet" },
  { value: "L'Île-Perrot", label: "L'Île-Perrot" },
  { value: "Lingwick", label: "Lingwick" },
  { value: "L'Islet", label: "L'Islet" },
  { value: "L'Isle-aux-Allumettes", label: "L'Isle-aux-Allumettes" },
  { value: "L'Isle-aux-Coudres", label: "L'Isle-aux-Coudres" },
  { value: "L'Isle-Verte", label: "L'Isle-Verte" },
  { value: "L'Islet-sur-Mer", label: "L'Islet-sur-Mer" },
  { value: "Listuguj", label: "Listuguj" },
  { value: "Litchfield", label: "Litchfield" },
  { value: "Lochaber", label: "Lochaber" },
  { value: "Lochaber-Partie-Ouest", label: "Lochaber-Partie-Ouest" },
  { value: "Longue-Pointe-de-Mingan", label: "Longue-Pointe-de-Mingan" },
  { value: "Longue-Rive", label: "Longue-Rive" },
  { value: "Longueuil", label: "Longueuil" },
  { value: "Lorraine", label: "Lorraine" },
  { value: "Lorrainville", label: "Lorrainville" },
  { value: "Lotbinière", label: "Lotbinière" },
  { value: "Louiseville", label: "Louiseville" },
  { value: "Low", label: "Low" },
  { value: "Lyster", label: "Lyster" },
  { value: "Macamic", label: "Macamic" },
  { value: "Maddington Falls", label: "Maddington Falls" },
  { value: "Magog", label: "Magog" },
  { value: "Malartic", label: "Malartic" },
  { value: "Mandeville", label: "Mandeville" },
  { value: "Maniwaki", label: "Maniwaki" },
  { value: "Manseau", label: "Manseau" },
  { value: "Mansfield-et-Pontefract", label: "Mansfield-et-Pontefract" },
  { value: "Manicouagan", label: "Manicouagan" },
  { value: "Manouane", label: "Manouane" },
  { value: "Maria", label: "Maria" },
  { value: "Maria-Chapdelaine", label: "Maria-Chapdelaine" },
  { value: "Marieville", label: "Marieville" },
  { value: "Marsoui", label: "Marsoui" },
  { value: "Marston", label: "Marston" },
  { value: "Martinville", label: "Martinville" },
  { value: "Mascouche", label: "Mascouche" },
  { value: "Maskinongé", label: "Maskinongé" },
  { value: "Matagami", label: "Matagami" },
  { value: "Matane", label: "Matane" },
  { value: "Matapédia", label: "Matapédia" },
  { value: "Matimekosh-Lac-John", label: "Matimekosh-Lac-John" },
  { value: "Mayo", label: "Mayo" },
  { value: "McMasterville", label: "McMasterville" },
  { value: "Mékinac", label: "Mékinac" },
  { value: "Melbourne", label: "Melbourne" },
  { value: "Melocheville", label: "Melocheville" },
  { value: "Memphrémagog", label: "Memphrémagog" },
  { value: "Mercier", label: "Mercier" },
  { value: "Messines", label: "Messines" },
  {
    value: "Métabetchouan-Lac-à-la-Croix",
    label: "Métabetchouan-Lac-à-la-Croix",
  },
  { value: "Métis-sur-Mer", label: "Métis-sur-Mer" },
  { value: "Milan", label: "Milan" },
  { value: "Minganie", label: "Minganie" },
  { value: "Mirabel", label: "Mirabel" },
  { value: "Mistissini", label: "Mistissini" },
  { value: "Montcalm", label: "Montcalm" },
  { value: "Montcerf-Lytton", label: "Montcerf-Lytton" },
  { value: "Mont-Carmel", label: "Mont-Carmel" },
  { value: "Montebello", label: "Montebello" },
  { value: "Montérégie", label: "Montérégie" },
  { value: "Mont-Joli", label: "Mont-Joli" },
  { value: "Mont-Laurier", label: "Mont-Laurier" },
  { value: "Montmagny", label: "Montmagny" },
  { value: "Montpellier", label: "Montpellier" },
  { value: "Montreal", label: "Montreal" },
  { value: "Montréal-Est", label: "Montréal-Est" },
  { value: "Mont-Royal", label: "Mont-Royal" },
  { value: "Mont-Saint-Grégoire", label: "Mont-Saint-Grégoire" },
  { value: "Mont-Saint-Hilaire", label: "Mont-Saint-Hilaire" },
  { value: "Mont-Saint-Michel", label: "Mont-Saint-Michel" },
  { value: "Mont-Saint-Pierre", label: "Mont-Saint-Pierre" },
  { value: "Mont-Tremblant", label: "Mont-Tremblant" },
  { value: "Morin-Heights", label: "Morin-Heights" },
  { value: "Mulgrave-et-Derry", label: "Mulgrave-et-Derry" },
  { value: "Murdochville", label: "Murdochville" },
  { value: "Namur", label: "Namur" },
  { value: "Nantes", label: "Nantes" },
  { value: "Napierville", label: "Napierville" },
  { value: "Natashquan", label: "Natashquan" },
  { value: "Nédélec", label: "Nédélec" },
  { value: "Nemaska", label: "Nemaska" },
  { value: "Neuville", label: "Neuville" },
  { value: "New Carlisle", label: "New Carlisle" },
  { value: "New Richmond", label: "New Richmond" },
  { value: "Newport", label: "Newport" },
  { value: "Nicolet", label: "Nicolet" },
  { value: "Nicolet-Yamaska", label: "Nicolet-Yamaska" },
  { value: "Nominingue", label: "Nominingue" },
  { value: "Normandin", label: "Normandin" },
  { value: "Normétal", label: "Normétal" },
  { value: "North Hatley", label: "North Hatley" },
  {
    value: "Notre-Dame-Auxiliatrice-de-Buckland",
    label: "Notre-Dame-Auxiliatrice-de-Buckland",
  },
  { value: "Notre-Dame-de-Bonsecours", label: "Notre-Dame-de-Bonsecours" },
  { value: "Notre-Dame-de-Ham", label: "Notre-Dame-de-Ham" },
  { value: "Notre-Dame-de-la-Merci", label: "Notre-Dame-de-la-Merci" },
  { value: "Notre-Dame-de-la-Paix", label: "Notre-Dame-de-la-Paix" },
  { value: "Notre-Dame-de-la-Salette", label: "Notre-Dame-de-la-Salette" },
  { value: "Notre-Dame-de-l'Île-Perrot", label: "Notre-Dame-de-l'Île-Perrot" },
  { value: "Notre-Dame-de-Lorette", label: "Notre-Dame-de-Lorette" },
  { value: "Notre-Dame-de-Lourdes", label: "Notre-Dame-de-Lourdes" },
  { value: "Notre-Dame-de-Montauban", label: "Notre-Dame-de-Montauban" },
  { value: "Notre-Dame-de-Pontmain", label: "Notre-Dame-de-Pontmain" },
  { value: "Notre-Dame-des-Anges", label: "Notre-Dame-des-Anges" },
  { value: "Notre-Dame-des-Bois", label: "Notre-Dame-des-Bois" },
  { value: "Notre-Dame-des-Monts", label: "Notre-Dame-des-Monts" },
  { value: "Notre-Dame-des-Neiges", label: "Notre-Dame-des-Neiges" },
  { value: "Notre-Dame-des-Pins", label: "Notre-Dame-des-Pins" },
  { value: "Notre-Dame-des-Prairies", label: "Notre-Dame-des-Prairies" },
  {
    value: "Notre-Dame-des-Sept-Douleurs",
    label: "Notre-Dame-des-Sept-Douleurs",
  },
  { value: "Notre-Dame-du-Bon-Conseil", label: "Notre-Dame-du-Bon-Conseil" },
  { value: "Notre-Dame-du-Lac", label: "Notre-Dame-du-Lac" },
  { value: "Notre-Dame-du-Laus", label: "Notre-Dame-du-Laus" },
  { value: "Notre-Dame-du-Mont-Carmel", label: "Notre-Dame-du-Mont-Carmel" },
  { value: "Notre-Dame-du-Nord", label: "Notre-Dame-du-Nord" },
  { value: "Notre-Dame-du-Portage", label: "Notre-Dame-du-Portage" },
  { value: "Notre-Dame-du-Rosaire", label: "Notre-Dame-du-Rosaire" },
  {
    value: "Notre-Dame-du-Sacré-Cœur-d'Issoudun",
    label: "Notre-Dame-du-Sacré-Cœur-d'Issoudun",
  },
  { value: "Nouvelle", label: "Nouvelle" },
  { value: "Noyan", label: "Noyan" },
  { value: "Obedjiwan", label: "Obedjiwan" },
  { value: "Odanak", label: "Odanak" },
  { value: "Ogden", label: "Ogden" },
  { value: "Oka", label: "Oka" },
  { value: "Orford", label: "Orford" },
  { value: "Ormstown", label: "Ormstown" },
  { value: "Otterburn Park", label: "Otterburn Park" },
  { value: "Packington", label: "Packington" },
  { value: "Padoue", label: "Padoue" },
  { value: "Palmarolle", label: "Palmarolle" },
  { value: "Papineauville", label: "Papineauville" },
  { value: "Papineau", label: "Papineau" },
  { value: "Parc-Boutin", label: "Parc-Boutin" },
  { value: "Parent", label: "Parent" },
  { value: "Parisville", label: "Parisville" },
  { value: "Paspébiac", label: "Paspébiac" },
  { value: "Péribonka", label: "Péribonka" },
  { value: "Percé", label: "Percé" },
  {
    value: "Petite-Rivière-Saint-François",
    label: "Petite-Rivière-Saint-François",
  },
  { value: "Petit-Saguenay", label: "Petit-Saguenay" },
  { value: "Piedmont", label: "Piedmont" },
  { value: "Pierreville", label: "Pierreville" },
  { value: "Pierre-De Saurel", label: "Pierre-De Saurel" },
  { value: "Pike River", label: "Pike River" },
  { value: "Pincourt", label: "Pincourt" },
  { value: "Piopolis", label: "Piopolis" },
  { value: "Plaisance", label: "Plaisance" },
  { value: "Plessisville", label: "Plessisville" },
  { value: "Pohénégamook", label: "Pohénégamook" },
  { value: "Pointe-à-la-Croix", label: "Pointe-à-la-Croix" },
  { value: "Pointe-aux-Outardes", label: "Pointe-aux-Outardes" },
  { value: "Pointe-aux-Trembles", label: "Pointe-aux-Trembles" },
  { value: "Pointe-Calumet", label: "Pointe-Calumet" },
  { value: "Pointe-Claire", label: "Pointe-Claire" },
  { value: "Pointe-des-Cascades", label: "Pointe-des-Cascades" },
  { value: "Pointe-Fortune", label: "Pointe-Fortune" },
  { value: "Pointe-Lebel", label: "Pointe-Lebel" },
  { value: "Pontiac", label: "Pontiac" },
  { value: "Pont-Rouge", label: "Pont-Rouge" },
  { value: "Portage-du-Fort", label: "Portage-du-Fort" },
  { value: "Port-Cartier", label: "Port-Cartier" },
  { value: "Port-Daniel-Gascons", label: "Port-Daniel-Gascons" },
  { value: "Portneuf", label: "Portneuf" },
  { value: "Portneuf-sur-Mer", label: "Portneuf-sur-Mer" },
  { value: "Potton", label: "Potton" },
  { value: "Poularies", label: "Poularies" },
  { value: "Preissac", label: "Preissac" },
  { value: "Prévost", label: "Prévost" },
  { value: "Price", label: "Price" },
  { value: "Princeville", label: "Princeville" },
  { value: "Québec", label: "Québec" },
  { value: "Racine", label: "Racine" },
  { value: "Ragueneau", label: "Ragueneau" },
  { value: "Rapide-Blanc", label: "Rapide-Blanc" },
  { value: "Rapide-Danseur", label: "Rapide-Danseur" },
  { value: "Rapides-des-Joachims", label: "Rapides-des-Joachims" },
  { value: "Rawdon", label: "Rawdon" },
  { value: "Rémigny", label: "Rémigny" },
  { value: "Repentigny", label: "Repentigny" },
  { value: "Richelieu", label: "Richelieu" },
  { value: "Richmond", label: "Richmond" },
  { value: "Rigaud", label: "Rigaud" },
  { value: "Rimouski", label: "Rimouski" },
  { value: "Rimouski-Neigette", label: "Rimouski-Neigette" },
  { value: "Ripon", label: "Ripon" },
  { value: "Ristigouche-Partie-Sud-Est", label: "Ristigouche-Partie-Sud-Est" },
  { value: "Rivière-à-Claude", label: "Rivière-à-Claude" },
  { value: "Rivière-à-Pierre", label: "Rivière-à-Pierre" },
  { value: "Rivière-au-Tonnerre", label: "Rivière-au-Tonnerre" },
  { value: "Rivière-Beaudette", label: "Rivière-Beaudette" },
  { value: "Rivière-Bleue", label: "Rivière-Bleue" },
  { value: "Rivière-du-Loup", label: "Rivière-du-Loup" },
  { value: "Rivière-Éternité", label: "Rivière-Éternité" },
  { value: "Rivière-Héva", label: "Rivière-Héva" },
  { value: "Rivière-Ojima", label: "Rivière-Ojima" },
  { value: "Rivière-Ouelle", label: "Rivière-Ouelle" },
  { value: "Rivière-Rouge", label: "Rivière-Rouge" },
  { value: "Rivière-Saint-Jean", label: "Rivière-Saint-Jean" },
  { value: "Roberval", label: "Roberval" },
  { value: "Robert-Cliche", label: "Robert-Cliche" },
  { value: "Rochebaucourt", label: "Rochebaucourt" },
  { value: "Roquemaure", label: "Roquemaure" },
  { value: "Rosemère", label: "Rosemère" },
  { value: "Rougemont", label: "Rougemont" },
  { value: "Rouyn-Noranda", label: "Rouyn-Noranda" },
  { value: "Roxton", label: "Roxton" },
  { value: "Roxton Falls", label: "Roxton Falls" },
  { value: "Roxton Pond", label: "Roxton Pond" },
  { value: "Roussillon", label: "Roussillon" },
  { value: "Sacré-Cœur", label: "Sacré-Cœur" },
  { value: "Sacré-Cœur-de-Jésus", label: "Sacré-Cœur-de-Jésus" },
  { value: "Saguenay", label: "Saguenay" },
  { value: "Saint-Adelme", label: "Saint-Adelme" },
  { value: "Saint-Adelphe", label: "Saint-Adelphe" },
  { value: "Saint-Adolphe-d'Howard", label: "Saint-Adolphe-d'Howard" },
  { value: "Saint-Adrien", label: "Saint-Adrien" },
  { value: "Saint-Adrien-d'Irlande", label: "Saint-Adrien-d'Irlande" },
  { value: "Saint-Agapit", label: "Saint-Agapit" },
  { value: "Saint-Aimé", label: "Saint-Aimé" },
  { value: "Saint-Aimé-des-Lacs", label: "Saint-Aimé-des-Lacs" },
  { value: "Saint-Aimé-du-Lac-des-Îles", label: "Saint-Aimé-du-Lac-des-Îles" },
  { value: "Saint-Alban", label: "Saint-Alban" },
  { value: "Saint-Albert", label: "Saint-Albert" },
  { value: "Saint-Alexandre", label: "Saint-Alexandre" },
  {
    value: "Saint-Alexandre-de-Kamouraska",
    label: "Saint-Alexandre-de-Kamouraska",
  },
  { value: "Saint-Alexandre-des-Lacs", label: "Saint-Alexandre-des-Lacs" },
  { value: "Saint-Alexis", label: "Saint-Alexis" },
  { value: "Saint-Alexis-de-Matapédia", label: "Saint-Alexis-de-Matapédia" },
  { value: "Saint-Alexis-des-Monts", label: "Saint-Alexis-des-Monts" },
  { value: "Saint-Alfred", label: "Saint-Alfred" },
  { value: "Saint-Alphonse", label: "Saint-Alphonse" },
  { value: "Saint-Alphonse-de-Granby", label: "Saint-Alphonse-de-Granby" },
  { value: "Saint-Alphonse-Rodriguez", label: "Saint-Alphonse-Rodriguez" },
  { value: "Saint-Amable", label: "Saint-Amable" },
  { value: "Saint-Ambroise", label: "Saint-Ambroise" },
  { value: "Saint-Ambroise-de-Kildare", label: "Saint-Ambroise-de-Kildare" },
  { value: "Saint-Anaclet-de-Lessard", label: "Saint-Anaclet-de-Lessard" },
  { value: "Saint-André", label: "Saint-André" },
  { value: "Saint-André-Avellin", label: "Saint-André-Avellin" },
  { value: "Saint-André-d'Argenteuil", label: "Saint-André-d'Argenteuil" },
  { value: "Saint-André-de-Restigouche", label: "Saint-André-de-Restigouche" },
  {
    value: "Saint-André-du-Lac-Saint-Jean",
    label: "Saint-André-du-Lac-Saint-Jean",
  },
  { value: "Saint-Anicet", label: "Saint-Anicet" },
  { value: "Saint-Anselme", label: "Saint-Anselme" },
  { value: "Saint-Antoine", label: "Saint-Antoine" },
  {
    value: "Saint-Antoine-de-l'Isle-aux-Grues",
    label: "Saint-Antoine-de-l'Isle-aux-Grues",
  },
  { value: "Saint-Antoine-de-Tilly", label: "Saint-Antoine-de-Tilly" },
  {
    value: "Saint-Antoine-sur-Richelieu",
    label: "Saint-Antoine-sur-Richelieu",
  },
  { value: "Saint-Antonin", label: "Saint-Antonin" },
  { value: "Saint-Apollinaire", label: "Saint-Apollinaire" },
  { value: "Saint-Armand", label: "Saint-Armand" },
  { value: "Saint-Arsène", label: "Saint-Arsène" },
  { value: "Saint-Athanase", label: "Saint-Athanase" },
  { value: "Saint-Aubert", label: "Saint-Aubert" },
  { value: "Saint-Augustin", label: "Saint-Augustin" },
  {
    value: "Saint-Augustin-de-Desmaures",
    label: "Saint-Augustin-de-Desmaures",
  },
  { value: "Saint-Augustin-de-Woburn", label: "Saint-Augustin-de-Woburn" },
  { value: "Saint-Barnabé", label: "Saint-Barnabé" },
  { value: "Saint-Barnabé-Sud", label: "Saint-Barnabé-Sud" },
  { value: "Saint-Barthélemy", label: "Saint-Barthélemy" },
  { value: "Saint-Basile", label: "Saint-Basile" },
  { value: "Saint-Basile-le-Grand", label: "Saint-Basile-le-Grand" },
  { value: "Saint-Benjamin", label: "Saint-Benjamin" },
  { value: "Saint-Benoît-du-Lac", label: "Saint-Benoît-du-Lac" },
  { value: "Saint-Benoît-Labre", label: "Saint-Benoît-Labre" },
  { value: "Saint-Bernard", label: "Saint-Bernard" },
  { value: "Saint-Bernard-de-Lacolle", label: "Saint-Bernard-de-Lacolle" },
  {
    value: "Saint-Bernard-de-Michaudville",
    label: "Saint-Bernard-de-Michaudville",
  },
  { value: "Saint-Blaise-sur-Richelieu", label: "Saint-Blaise-sur-Richelieu" },
  { value: "Saint-Bonaventure", label: "Saint-Bonaventure" },
  { value: "Saint-Boniface", label: "Saint-Boniface" },
  { value: "Saint-Bruno", label: "Saint-Bruno" },
  { value: "Saint-Bruno-de-Guigues", label: "Saint-Bruno-de-Guigues" },
  { value: "Saint-Bruno-de-Kamouraska", label: "Saint-Bruno-de-Kamouraska" },
  { value: "Saint-Bruno-de-Montarville", label: "Saint-Bruno-de-Montarville" },
  { value: "Saint-Calixte", label: "Saint-Calixte" },
  { value: "Saint-Camille", label: "Saint-Camille" },
  { value: "Saint-Camille-de-Lellis", label: "Saint-Camille-de-Lellis" },
  { value: "Saint-Casimir", label: "Saint-Casimir" },
  { value: "Saint-Célestin", label: "Saint-Célestin" },
  { value: "Saint-Césaire", label: "Saint-Césaire" },
  { value: "Saint-Charles-Borromée", label: "Saint-Charles-Borromée" },
  {
    value: "Saint-Charles-de-Bellechasse",
    label: "Saint-Charles-de-Bellechasse",
  },
  { value: "Saint-Charles-de-Bourget", label: "Saint-Charles-de-Bourget" },
  { value: "Saint-Charles-Garnier", label: "Saint-Charles-Garnier" },
  {
    value: "Saint-Charles-sur-Richelieu",
    label: "Saint-Charles-sur-Richelieu",
  },
  {
    value: "Saint-Christophe-d'Arthabaska",
    label: "Saint-Christophe-d'Arthabaska",
  },
  { value: "Saint-Chrysostome", label: "Saint-Chrysostome" },
  { value: "Saint-Claude", label: "Saint-Claude" },
  { value: "Saint-Clément", label: "Saint-Clément" },
  { value: "Saint-Cléophas", label: "Saint-Cléophas" },
  { value: "Saint-Cléophas-de-Brandon", label: "Saint-Cléophas-de-Brandon" },
  { value: "Saint-Clet", label: "Saint-Clet" },
  { value: "Saint-Colomban", label: "Saint-Colomban" },
  { value: "Saint-Côme", label: "Saint-Côme" },
  { value: "Saint-Côme-Linière", label: "Saint-Côme-Linière" },
  { value: "Saint-Constant", label: "Saint-Constant" },
  { value: "Saint-Cuthbert", label: "Saint-Cuthbert" },
  { value: "Saint-Cyprien", label: "Saint-Cyprien" },
  {
    value: "Saint-Cyprien-de-Napierville",
    label: "Saint-Cyprien-de-Napierville",
  },
  { value: "Saint-Cyrille-de-Lessard", label: "Saint-Cyrille-de-Lessard" },
  { value: "Saint-Cyrille-de-Wendover", label: "Saint-Cyrille-de-Wendover" },
  { value: "Saint-Damase", label: "Saint-Damase" },
  { value: "Saint-Damase-de-L'Islet", label: "Saint-Damase-de-L'Islet" },
  { value: "Saint-Damien", label: "Saint-Damien" },
  { value: "Saint-Damien-de-Buckland", label: "Saint-Damien-de-Buckland" },
  { value: "Saint-David", label: "Saint-David" },
  { value: "Saint-David-de-Falardeau", label: "Saint-David-de-Falardeau" },
  {
    value: "Saint-Denis-de-la-Bouteillerie",
    label: "Saint-Denis-de-la-Bouteillerie",
  },
  { value: "Saint-Denis-de-Brompton", label: "Saint-Denis-de-Brompton" },
  { value: "Saint-Denis-sur-Richelieu", label: "Saint-Denis-sur-Richelieu" },
  { value: "Saint-Didace", label: "Saint-Didace" },
  { value: "Saint-Dominique", label: "Saint-Dominique" },
  { value: "Saint-Dominique-du-Rosaire", label: "Saint-Dominique-du-Rosaire" },
  { value: "Saint-Donat", label: "Saint-Donat" },
  { value: "Sainte-Adèle", label: "Sainte-Adèle" },
  {
    value: "Sainte-Agathe-de-Lotbinière",
    label: "Sainte-Agathe-de-Lotbinière",
  },
  { value: "Sainte-Agathe-des-Monts", label: "Sainte-Agathe-des-Monts" },
  { value: "Sainte-Angèle-de-Mérici", label: "Sainte-Angèle-de-Mérici" },
  { value: "Sainte-Angèle-de-Monnoir", label: "Sainte-Angèle-de-Monnoir" },
  { value: "Sainte-Angèle-de-Prémont", label: "Sainte-Angèle-de-Prémont" },
  { value: "Sainte-Anne-de-Beaupré", label: "Sainte-Anne-de-Beaupré" },
  { value: "Sainte-Anne-de-Bellevue", label: "Sainte-Anne-de-Bellevue" },
  { value: "Sainte-Anne-de-la-Pérade", label: "Sainte-Anne-de-la-Pérade" },
  {
    value: "Sainte-Anne-de-la-Pocatière",
    label: "Sainte-Anne-de-la-Pocatière",
  },
  { value: "Sainte-Anne-de-la-Rochelle", label: "Sainte-Anne-de-la-Rochelle" },
  { value: "Sainte-Anne-de-Sabrevois", label: "Sainte-Anne-de-Sabrevois" },
  { value: "Sainte-Anne-des-Lacs", label: "Sainte-Anne-des-Lacs" },
  { value: "Sainte-Anne-des-Monts", label: "Sainte-Anne-des-Monts" },
  { value: "Sainte-Anne-de-Sorel", label: "Sainte-Anne-de-Sorel" },
  { value: "Sainte-Anne-des-Plaines", label: "Sainte-Anne-des-Plaines" },
  { value: "Sainte-Anne-du-Lac", label: "Sainte-Anne-du-Lac" },
  { value: "Sainte-Apolline-de-Patton", label: "Sainte-Apolline-de-Patton" },
  { value: "Sainte-Aurélie", label: "Sainte-Aurélie" },
  { value: "Sainte-Barbe", label: "Sainte-Barbe" },
  { value: "Sainte-Béatrix", label: "Sainte-Béatrix" },
  { value: "Sainte-Brigide-d'Iberville", label: "Sainte-Brigide-d'Iberville" },
  { value: "Sainte-Brigitte-de-Laval", label: "Sainte-Brigitte-de-Laval" },
  { value: "Sainte-Brigitte-des-Saults", label: "Sainte-Brigitte-des-Saults" },
  { value: "Sainte-Catherine", label: "Sainte-Catherine" },
  { value: "Sainte-Catherine-de-Hatley", label: "Sainte-Catherine-de-Hatley" },
  {
    value: "Sainte-Catherine-de-la-Jacques-Cartier",
    label: "Sainte-Catherine-de-la-Jacques-Cartier",
  },
  { value: "Sainte-Cécile-de-Lévrard", label: "Sainte-Cécile-de-Lévrard" },
  { value: "Sainte-Cécile-de-Milton", label: "Sainte-Cécile-de-Milton" },
  { value: "Sainte-Cécile-de-Whitton", label: "Sainte-Cécile-de-Whitton" },
  { value: "Sainte-Christine", label: "Sainte-Christine" },
  {
    value: "Sainte-Christine-d'Auvergne",
    label: "Sainte-Christine-d'Auvergne",
  },
  { value: "Sainte-Claire", label: "Sainte-Claire" },
  { value: "Sainte-Clotilde", label: "Sainte-Clotilde" },
  { value: "Sainte-Clotilde-de-Beauce", label: "Sainte-Clotilde-de-Beauce" },
  { value: "Sainte-Clotilde-de-Horton", label: "Sainte-Clotilde-de-Horton" },
  { value: "Sainte-Croix", label: "Sainte-Croix" },
  { value: "Saint-Edmond-de-Grantham", label: "Saint-Edmond-de-Grantham" },
  { value: "Saint-Edmond-les-Plaines", label: "Saint-Edmond-les-Plaines" },
  { value: "Saint-Édouard", label: "Saint-Édouard" },
  { value: "Saint-Édouard-de-Fabre", label: "Saint-Édouard-de-Fabre" },
  {
    value: "Saint-Édouard-de-Lotbinière",
    label: "Saint-Édouard-de-Lotbinière",
  },
  {
    value: "Saint-Édouard-de-Maskinongé",
    label: "Saint-Édouard-de-Maskinongé",
  },
  { value: "Sainte-Edwidge-de-Clifton", label: "Sainte-Edwidge-de-Clifton" },
  { value: "Sainte-Élisabeth", label: "Sainte-Élisabeth" },
  {
    value: "Sainte-Élizabeth-de-Warwick",
    label: "Sainte-Élizabeth-de-Warwick",
  },
  { value: "Sainte-Émélie-de-l'Énergie", label: "Sainte-Émélie-de-l'Énergie" },
  { value: "Sainte-Eulalie", label: "Sainte-Eulalie" },
  {
    value: "Sainte-Euphémie-sur-Rivière-du-Sud",
    label: "Sainte-Euphémie-sur-Rivière-du-Sud",
  },
  {
    value: "Sainte-Famille-de-l'Île-d'Orléans",
    label: "Sainte-Famille-de-l'Île-d'Orléans",
  },
  { value: "Sainte-Félicité", label: "Sainte-Félicité" },
  { value: "Sainte-Flavie", label: "Sainte-Flavie" },
  { value: "Sainte-Florence", label: "Sainte-Florence" },
  { value: "Sainte-Françoise", label: "Sainte-Françoise" },
  {
    value: "Sainte-Geneviève-de-Batiscan",
    label: "Sainte-Geneviève-de-Batiscan",
  },
  {
    value: "Sainte-Geneviève-de-Berthier",
    label: "Sainte-Geneviève-de-Berthier",
  },
  { value: "Sainte-Germaine-Boulé", label: "Sainte-Germaine-Boulé" },
  { value: "Sainte-Gertrude-Manneville", label: "Sainte-Gertrude-Manneville" },
  { value: "Sainte-Hedwidge", label: "Sainte-Hedwidge" },
  {
    value: "Sainte-Hélène-de-Kamouraska",
    label: "Sainte-Hélène-de-Kamouraska",
  },
  { value: "Sainte-Hélène-de-Bagot", label: "Sainte-Hélène-de-Bagot" },
  { value: "Sainte-Hélène-de-Chester", label: "Sainte-Hélène-de-Chester" },
  {
    value: "Sainte-Hélène-de-Mancebourg",
    label: "Sainte-Hélène-de-Mancebourg",
  },
  { value: "Sainte-Hénédine", label: "Sainte-Hénédine" },
  { value: "Sainte-Irène", label: "Sainte-Irène" },
  { value: "Sainte-Jeanne-d'Arc", label: "Sainte-Jeanne-d'Arc" },
  { value: "Sainte-Julie", label: "Sainte-Julie" },
  { value: "Sainte-Julienne", label: "Sainte-Julienne" },
  { value: "Sainte-Justine", label: "Sainte-Justine" },
  { value: "Sainte-Justine-de-Newton", label: "Sainte-Justine-de-Newton" },
  { value: "Saint-Élie-de-Caxton", label: "Saint-Élie-de-Caxton" },
  { value: "Saint-Éloi", label: "Saint-Éloi" },
  { value: "Sainte-Louise", label: "Sainte-Louise" },
  { value: "Saint-Elphège", label: "Saint-Elphège" },
  { value: "Sainte-Luce", label: "Sainte-Luce" },
  { value: "Sainte-Lucie-de-Beauregard", label: "Sainte-Lucie-de-Beauregard" },
  {
    value: "Sainte-Lucie-des-Laurentides",
    label: "Sainte-Lucie-des-Laurentides",
  },
  { value: "Saint-Elzéar", label: "Saint-Elzéar" },
  {
    value: "Saint-Elzéar-de-Témiscouata",
    label: "Saint-Elzéar-de-Témiscouata",
  },
  { value: "Sainte-Madeleine", label: "Sainte-Madeleine" },
  {
    value: "Sainte-Madeleine-de-la-Rivière-Madeleine",
    label: "Sainte-Madeleine-de-la-Rivière-Madeleine",
  },
  {
    value: "Sainte-Marcelline-de-Kildare",
    label: "Sainte-Marcelline-de-Kildare",
  },
  { value: "Sainte-Marguerite", label: "Sainte-Marguerite" },
  {
    value: "Sainte-Marguerite-du-Lac-Masson",
    label: "Sainte-Marguerite-du-Lac-Masson",
  },
  { value: "Sainte-Marguerite-Marie", label: "Sainte-Marguerite-Marie" },
  { value: "Sainte-Marie", label: "Sainte-Marie" },
  { value: "Sainte-Marie-de-Blandford", label: "Sainte-Marie-de-Blandford" },
  { value: "Sainte-Marie-Madeleine", label: "Sainte-Marie-Madeleine" },
  { value: "Sainte-Marie-Salomé", label: "Sainte-Marie-Salomé" },
  { value: "Sainte-Marthe", label: "Sainte-Marthe" },
  { value: "Sainte-Marthe-sur-le-Lac", label: "Sainte-Marthe-sur-le-Lac" },
  { value: "Sainte-Martine", label: "Sainte-Martine" },
  { value: "Sainte-Mélanie", label: "Sainte-Mélanie" },
  { value: "Saint-Émile-de-Suffolk", label: "Saint-Émile-de-Suffolk" },
  { value: "Sainte-Monique", label: "Sainte-Monique" },
  { value: "Sainte-Paule", label: "Sainte-Paule" },
  { value: "Sainte-Perpétue", label: "Sainte-Perpétue" },
  { value: "Sainte-Pétronille", label: "Sainte-Pétronille" },
  { value: "Saint-Éphrem-de-Beauce", label: "Saint-Éphrem-de-Beauce" },
  { value: "Saint-Épiphane", label: "Saint-Épiphane" },
  { value: "Sainte-Praxède", label: "Sainte-Praxède" },
  { value: "Sainte-Rita", label: "Sainte-Rita" },
  { value: "Sainte-Rose-de-Watford", label: "Sainte-Rose-de-Watford" },
  { value: "Sainte-Rose-du-Nord", label: "Sainte-Rose-du-Nord" },
  { value: "Sainte-Sabine", label: "Sainte-Sabine" },
  { value: "Sainte-Séraphine", label: "Sainte-Séraphine" },
  { value: "Sainte-Sophie", label: "Sainte-Sophie" },
  { value: "Sainte-Sophie-de-Lévrard", label: "Sainte-Sophie-de-Lévrard" },
  { value: "Sainte-Sophie-d'Halifax", label: "Sainte-Sophie-d'Halifax" },
  { value: "Saint-Esprit", label: "Saint-Esprit" },
  { value: "Sainte-Thècle", label: "Sainte-Thècle" },
  { value: "Sainte-Thérèse", label: "Sainte-Thérèse" },
  { value: "Sainte-Thérèse-de-Gaspé", label: "Sainte-Thérèse-de-Gaspé" },
  {
    value: "Sainte-Thérèse-de-la-Gatineau",
    label: "Sainte-Thérèse-de-la-Gatineau",
  },
  {
    value: "Saint-Étienne-de-Beauharnois",
    label: "Saint-Étienne-de-Beauharnois",
  },
  { value: "Saint-Étienne-de-Bolton", label: "Saint-Étienne-de-Bolton" },
  { value: "Saint-Étienne-des-Grès", label: "Saint-Étienne-des-Grès" },
  { value: "Saint-Eugène", label: "Saint-Eugène" },
  { value: "Saint-Eugène-d'Argentenay", label: "Saint-Eugène-d'Argentenay" },
  { value: "Saint-Eugène-de-Guigues", label: "Saint-Eugène-de-Guigues" },
  { value: "Saint-Eugène-de-Ladrière", label: "Saint-Eugène-de-Ladrière" },
  { value: "Sainte-Ursule", label: "Sainte-Ursule" },
  { value: "Saint-Eusèbe", label: "Saint-Eusèbe" },
  { value: "Saint-Eustache", label: "Saint-Eustache" },
  { value: "Saint-Évariste-de-Forsyth", label: "Saint-Évariste-de-Forsyth" },
  { value: "Sainte-Victoire-de-Sorel", label: "Sainte-Victoire-de-Sorel" },
  { value: "Saint-Fabien", label: "Saint-Fabien" },
  { value: "Saint-Fabien-de-Panet", label: "Saint-Fabien-de-Panet" },
  { value: "Saint-Faustin--Lac-Carré", label: "Saint-Faustin--Lac-Carré" },
  { value: "Saint-Félicien", label: "Saint-Félicien" },
  { value: "Saint-Félix-de-Dalquier", label: "Saint-Félix-de-Dalquier" },
  { value: "Saint-Félix-de-Kingsey", label: "Saint-Félix-de-Kingsey" },
  { value: "Saint-Félix-de-Valois", label: "Saint-Félix-de-Valois" },
  { value: "Saint-Félix-d'Otis", label: "Saint-Félix-d'Otis" },
  { value: "Saint-Ferdinand", label: "Saint-Ferdinand" },
  { value: "Saint-Ferréol-les-Neiges", label: "Saint-Ferréol-les-Neiges" },
  { value: "Saint-Flavien", label: "Saint-Flavien" },
  { value: "Saint-Fortunat", label: "Saint-Fortunat" },
  { value: "Saint-François-d'Assise", label: "Saint-François-d'Assise" },
  {
    value: "Saint-François-de-la-Rivière-du-Sud",
    label: "Saint-François-de-la-Rivière-du-Sud",
  },
  {
    value: "Saint-François-de-l'Île-d'Orléans",
    label: "Saint-François-de-l'Île-d'Orléans",
  },
  { value: "Saint-François-de-Sales", label: "Saint-François-de-Sales" },
  { value: "Saint-François-du-Lac", label: "Saint-François-du-Lac" },
  {
    value: "Saint-François-Xavier-de-Brompton",
    label: "Saint-François-Xavier-de-Brompton",
  },
  {
    value: "Saint-François-Xavier-de-Viger",
    label: "Saint-François-Xavier-de-Viger",
  },
  { value: "Saint-Frédéric", label: "Saint-Frédéric" },
  { value: "Saint-Fulgence", label: "Saint-Fulgence" },
  { value: "Saint-Gabriel", label: "Saint-Gabriel" },
  { value: "Saint-Gabriel-de-Brandon", label: "Saint-Gabriel-de-Brandon" },
  { value: "Saint-Gabriel-de-Rimouski", label: "Saint-Gabriel-de-Rimouski" },
  {
    value: "Saint-Gabriel-de-Valcartier",
    label: "Saint-Gabriel-de-Valcartier",
  },
  { value: "Saint-Gabriel-Lalemant", label: "Saint-Gabriel-Lalemant" },
  { value: "Saint-Gédéon", label: "Saint-Gédéon" },
  { value: "Saint-Gédéon-de-Beauce", label: "Saint-Gédéon-de-Beauce" },
  { value: "Saint-Georges", label: "Saint-Georges" },
  {
    value: "Saint-Georges-de-Clarenceville",
    label: "Saint-Georges-de-Clarenceville",
  },
  { value: "Saint-Georges-de-Windsor", label: "Saint-Georges-de-Windsor" },
  { value: "Saint-Gérard-Majella", label: "Saint-Gérard-Majella" },
  { value: "Saint-Germain", label: "Saint-Germain" },
  { value: "Saint-Germain-de-Grantham", label: "Saint-Germain-de-Grantham" },
  { value: "Saint-Gervais", label: "Saint-Gervais" },
  { value: "Saint-Gilbert", label: "Saint-Gilbert" },
  { value: "Saint-Gilles", label: "Saint-Gilles" },
  { value: "Saint-Godefroi", label: "Saint-Godefroi" },
  { value: "Saint-Guillaume", label: "Saint-Guillaume" },
  { value: "Saint-Guy", label: "Saint-Guy" },
  { value: "Saint-Henri", label: "Saint-Henri" },
  { value: "Saint-Henri-de-Taillon", label: "Saint-Henri-de-Taillon" },
  { value: "Saint-Herménégilde", label: "Saint-Herménégilde" },
  { value: "Saint-Hilaire-de-Dorset", label: "Saint-Hilaire-de-Dorset" },
  { value: "Saint-Hilarion", label: "Saint-Hilarion" },
  { value: "Saint-Hippolyte", label: "Saint-Hippolyte" },
  { value: "Saint-Honoré", label: "Saint-Honoré" },
  { value: "Saint-Honoré-de-Shenley", label: "Saint-Honoré-de-Shenley" },
  {
    value: "Saint-Honoré-de-Témiscouata",
    label: "Saint-Honoré-de-Témiscouata",
  },
  {
    value: "Saint-Hubert-de-Rivière-du-Loup",
    label: "Saint-Hubert-de-Rivière-du-Loup",
  },
  { value: "Saint-Hugues", label: "Saint-Hugues" },
  { value: "Saint-Hyacinthe", label: "Saint-Hyacinthe" },
  { value: "Saint-Ignace-de-Loyola", label: "Saint-Ignace-de-Loyola" },
  { value: "Saint-Ignace-de-Stanbridge", label: "Saint-Ignace-de-Stanbridge" },
  { value: "Saint-Irenée", label: "Saint-Irenée" },
  { value: "Saint-Isidore", label: "Saint-Isidore" },
  { value: "Saint-Isidore-d'Auckland", label: "Saint-Isidore-d'Auckland" },
  { value: "Saint-Isidore-de-Clifton", label: "Saint-Isidore-de-Clifton" },
  { value: "Saint-Jacques", label: "Saint-Jacques" },
  { value: "Saint-Jacques-de-Leeds", label: "Saint-Jacques-de-Leeds" },
  {
    value: "Saint-Jacques-le-Majeur-de-Wolfestown",
    label: "Saint-Jacques-le-Majeur-de-Wolfestown",
  },
  { value: "Saint-Jean-Baptiste", label: "Saint-Jean-Baptiste" },
  { value: "Saint-Jean-de-Brébeuf", label: "Saint-Jean-de-Brébeuf" },
  { value: "Saint-Jean-de-Cherbourg", label: "Saint-Jean-de-Cherbourg" },
  { value: "Saint-Jean-de-Dieu", label: "Saint-Jean-de-Dieu" },
  {
    value: "Saint-Jean-de-l'Île-d'Orléans",
    label: "Saint-Jean-de-l'Île-d'Orléans",
  },
  { value: "Saint-Jean-de-Matha", label: "Saint-Jean-de-Matha" },
  { value: "Saint-Jean-Port-Joli", label: "Saint-Jean-Port-Joli" },
  { value: "Saint-Jean-sur-Richelieu", label: "Saint-Jean-sur-Richelieu" },
  { value: "Saint-Jérôme", label: "Saint-Jérôme" },
  { value: "Saint-Joachim", label: "Saint-Joachim" },
  { value: "Saint-Joachim-de-Shefford", label: "Saint-Joachim-de-Shefford" },
  { value: "Saint-Joseph-de-Beauce", label: "Saint-Joseph-de-Beauce" },
  { value: "Saint-Joseph-de-Coleraine", label: "Saint-Joseph-de-Coleraine" },
  { value: "Saint-Joseph-de-Kamouraska", label: "Saint-Joseph-de-Kamouraska" },
  { value: "Saint-Joseph-de-Lanoraie", label: "Saint-Joseph-de-Lanoraie" },
  { value: "Saint-Joseph-de-Maskinongé", label: "Saint-Joseph-de-Maskinongé" },
  { value: "Saint-Joseph-de-Sorel", label: "Saint-Joseph-de-Sorel" },
  { value: "Saint-Joseph-du-Lac", label: "Saint-Joseph-du-Lac" },
  { value: "Saint-Jude", label: "Saint-Jude" },
  { value: "Saint-Jules", label: "Saint-Jules" },
  { value: "Saint-Julien", label: "Saint-Julien" },
  { value: "Saint-Just-de-Bretenières", label: "Saint-Just-de-Bretenières" },
  { value: "Saint-Juste-du-Lac", label: "Saint-Juste-du-Lac" },
  { value: "Saint-Justin", label: "Saint-Justin" },
  { value: "Saint-Lambert", label: "Saint-Lambert" },
  { value: "Saint-Lambert-de-Lauzon", label: "Saint-Lambert-de-Lauzon" },
  { value: "Saint-Laurent", label: "Saint-Laurent" },
  {
    value: "Saint-Laurent-de-l'Île-d'Orléans",
    label: "Saint-Laurent-de-l'Île-d'Orléans",
  },
  { value: "Saint-Lazare", label: "Saint-Lazare" },
  {
    value: "Saint-Lazare-de-Bellechasse",
    label: "Saint-Lazare-de-Bellechasse",
  },
  { value: "Saint-Léandre", label: "Saint-Léandre" },
  { value: "Saint-Léon", label: "Saint-Léon" },
  { value: "Saint-Léon-de-Standon", label: "Saint-Léon-de-Standon" },
  { value: "Saint-Léon-le-Grand", label: "Saint-Léon-le-Grand" },
  { value: "Saint-Léonard", label: "Saint-Léonard" },
  { value: "Saint-Léonard-d'Aston", label: "Saint-Léonard-d'Aston" },
  { value: "Saint-Léonard-de-Portneuf", label: "Saint-Léonard-de-Portneuf" },
  { value: "Saint-Liboire", label: "Saint-Liboire" },
  { value: "Saint-Lin-Laurentides", label: "Saint-Lin-Laurentides" },
  { value: "Saint-Louis", label: "Saint-Louis" },
  { value: "Saint-Louis-de-Blandford", label: "Saint-Louis-de-Blandford" },
  { value: "Saint-Louis-de-Gonzague", label: "Saint-Louis-de-Gonzague" },
  { value: "Saint-Louis-du-Ha! Ha!", label: "Saint-Louis-du-Ha! Ha!" },
  { value: "Saint-Luc-de-Bellechasse", label: "Saint-Luc-de-Bellechasse" },
  { value: "Saint-Luc-de-Vincennes", label: "Saint-Luc-de-Vincennes" },
  { value: "Saint-Lucien", label: "Saint-Lucien" },
  { value: "Saint-Ludger", label: "Saint-Ludger" },
  { value: "Saint-Ludger-de-Milot", label: "Saint-Ludger-de-Milot" },
  { value: "Saint-Marc-de-Figuery", label: "Saint-Marc-de-Figuery" },
  { value: "Saint-Marc-des-Carrières", label: "Saint-Marc-des-Carrières" },
  { value: "Saint-Marc-du-Lac-Long", label: "Saint-Marc-du-Lac-Long" },
  { value: "Saint-Marc-sur-Richelieu", label: "Saint-Marc-sur-Richelieu" },
  { value: "Saint-Marcellin", label: "Saint-Marcellin" },
  { value: "Saint-Martial", label: "Saint-Martial" },
  { value: "Saint-Martin", label: "Saint-Martin" },
  {
    value: "Saint-Mathias-sur-Richelieu",
    label: "Saint-Mathias-sur-Richelieu",
  },
  { value: "Saint-Mathieu", label: "Saint-Mathieu" },
  { value: "Saint-Mathieu-d'Harricana", label: "Saint-Mathieu-d'Harricana" },
  { value: "Saint-Mathieu-de-Beloeil", label: "Saint-Mathieu-de-Beloeil" },
  { value: "Saint-Mathieu-de-Rioux", label: "Saint-Mathieu-de-Rioux" },
  { value: "Saint-Mathieu-du-Parc", label: "Saint-Mathieu-du-Parc" },
  { value: "Saint-Maurice", label: "Saint-Maurice" },
  { value: "Saint-Maxime-du-Mont-Louis", label: "Saint-Maxime-du-Mont-Louis" },
  { value: "Saint-Médard", label: "Saint-Médard" },
  { value: "Saint-Méthode", label: "Saint-Méthode" },
  { value: "Saint-Michel", label: "Saint-Michel" },
  {
    value: "Saint-Michel-de-Bellechasse",
    label: "Saint-Michel-de-Bellechasse",
  },
  { value: "Saint-Michel-des-Saints", label: "Saint-Michel-des-Saints" },
  { value: "Saint-Michel-du-Squatec", label: "Saint-Michel-du-Squatec" },
  { value: "Saint-Moïse", label: "Saint-Moïse" },
  { value: "Saint-Narcisse", label: "Saint-Narcisse" },
  {
    value: "Saint-Narcisse-de-Beaurivage",
    label: "Saint-Narcisse-de-Beaurivage",
  },
  { value: "Saint-Narcisse-de-Rimouski", label: "Saint-Narcisse-de-Rimouski" },
  { value: "Saint-Nazaire", label: "Saint-Nazaire" },
  { value: "Saint-Nazaire-d'Acton", label: "Saint-Nazaire-d'Acton" },
  {
    value: "Saint-Nazaire-de-Dorchester",
    label: "Saint-Nazaire-de-Dorchester",
  },
  { value: "Saint-Nérée", label: "Saint-Nérée" },
  { value: "Saint-Nérée-de-Bellechasse", label: "Saint-Nérée-de-Bellechasse" },
  { value: "Saint-Nicéphore", label: "Saint-Nicéphore" },
  { value: "Saint-Nicolas", label: "Saint-Nicolas" },
  { value: "Saint-Norbert", label: "Saint-Norbert" },
  { value: "Saint-Norbert-d'Arthabaska", label: "Saint-Norbert-d'Arthabaska" },
  { value: "Saint-Octave-de-Métis", label: "Saint-Octave-de-Métis" },
  { value: "Saint-Octave-de-l'Avenir", label: "Saint-Octave-de-l'Avenir" },
  { value: "Saint-Odilon-de-Cranbourne", label: "Saint-Odilon-de-Cranbourne" },
  { value: "Saint-Omer", label: "Saint-Omer" },
  { value: "Saint-Onésime-d'Ixworth", label: "Saint-Onésime-d'Ixworth" },
  { value: "Saint-Ours", label: "Saint-Ours" },
  { value: "Saint-Pacôme", label: "Saint-Pacôme" },
  { value: "Saint-Pamphile", label: "Saint-Pamphile" },
  { value: "Saint-Paschal", label: "Saint-Paschal" },
  {
    value: "Saint-Patrice-de-Beaurivage",
    label: "Saint-Patrice-de-Beaurivage",
  },
  {
    value: "Saint-Patrice-de-Sherrington",
    label: "Saint-Patrice-de-Sherrington",
  },
  { value: "Saint-Patrick-d'Irlande", label: "Saint-Patrick-d'Irlande" },
  { value: "Saint-Paul", label: "Saint-Paul" },
  { value: "Saint-Paul-d'Abbotsford", label: "Saint-Paul-d'Abbotsford" },
  {
    value: "Saint-Paul-de-l'Île-aux-Noix",
    label: "Saint-Paul-de-l'Île-aux-Noix",
  },
  { value: "Saint-Paul-de-Montminy", label: "Saint-Paul-de-Montminy" },
  { value: "Saint-Paul-du-Nord", label: "Saint-Paul-du-Nord" },
  { value: "Saint-Paulin", label: "Saint-Paulin" },
  { value: "Saint-Philippe", label: "Saint-Philippe" },
  { value: "Saint-Philippe-de-Néri", label: "Saint-Philippe-de-Néri" },
  { value: "Saint-Pie", label: "Saint-Pie" },
  { value: "Saint-Pie-de-Guire", label: "Saint-Pie-de-Guire" },
  { value: "Saint-Pierre", label: "Saint-Pierre" },
  { value: "Saint-Pierre-Baptiste", label: "Saint-Pierre-Baptiste" },
  { value: "Saint-Pierre-de-Broughton", label: "Saint-Pierre-de-Broughton" },
  {
    value: "Saint-Pierre-de-l'Île-d'Orléans",
    label: "Saint-Pierre-de-l'Île-d'Orléans",
  },
  {
    value: "Saint-Pierre-de-la-Rivière-du-Sud",
    label: "Saint-Pierre-de-la-Rivière-du-Sud",
  },
  { value: "Saint-Pierre-de-Lamy", label: "Saint-Pierre-de-Lamy" },
  { value: "Saint-Pierre-les-Becquets", label: "Saint-Pierre-les-Becquets" },
  { value: "Saint-Placide", label: "Saint-Placide" },
  { value: "Saint-Polycarpe", label: "Saint-Polycarpe" },
  { value: "Saint-Prime", label: "Saint-Prime" },
  { value: "Saint-Prosper", label: "Saint-Prosper" },
  {
    value: "Saint-Prosper-de-Dorchester",
    label: "Saint-Prosper-de-Dorchester",
  },
  { value: "Saint-Raphaël", label: "Saint-Raphaël" },
  { value: "Saint-Raymond", label: "Saint-Raymond" },
  { value: "Saint-Rédempteur", label: "Saint-Rédempteur" },
  { value: "Saint-Rémi", label: "Saint-Rémi" },
  { value: "Saint-Rémi-de-Tingwick", label: "Saint-Rémi-de-Tingwick" },
  { value: "Saint-René", label: "Saint-René" },
  { value: "Saint-René-de-Matane", label: "Saint-René-de-Matane" },
  { value: "Saint-Robert", label: "Saint-Robert" },
  { value: "Saint-Robert-Bellarmin", label: "Saint-Robert-Bellarmin" },
  { value: "Saint-Roch-de-l'Achigan", label: "Saint-Roch-de-l'Achigan" },
  { value: "Saint-Roch-de-Mékinac", label: "Saint-Roch-de-Mékinac" },
  { value: "Saint-Roch-de-Richelieu", label: "Saint-Roch-de-Richelieu" },
  { value: "Saint-Roch-des-Aulnaies", label: "Saint-Roch-des-Aulnaies" },
  { value: "Saint-Roch-Ouest", label: "Saint-Roch-Ouest" },
  { value: "Saint-Rosaire", label: "Saint-Rosaire" },
  { value: "Saint-Samuel", label: "Saint-Samuel" },
  { value: "Saint-Sauveur", label: "Saint-Sauveur" },
  { value: "Saint-Sébastien", label: "Saint-Sébastien" },
  { value: "Saint-Sévère", label: "Saint-Sévère" },
  { value: "Saint-Séverin", label: "Saint-Séverin" },
  { value: "Saint-Séverin-de-Beauce", label: "Saint-Séverin-de-Beauce" },
  { value: "Saint-Siméon", label: "Saint-Siméon" },
  { value: "Saint-Simon", label: "Saint-Simon" },
  { value: "Saint-Simon-les-Mines", label: "Saint-Simon-les-Mines" },
  { value: "Saint-Stanislas", label: "Saint-Stanislas" },
  { value: "Saint-Stanislas-de-Kostka", label: "Saint-Stanislas-de-Kostka" },
  { value: "Saint-Sulpice", label: "Saint-Sulpice" },
  { value: "Saint-Sylvère", label: "Saint-Sylvère" },
  { value: "Saint-Sylvestre", label: "Saint-Sylvestre" },
  { value: "Saint-Télesphore", label: "Saint-Télesphore" },
  { value: "Saint-Tharcisius", label: "Saint-Tharcisius" },
  { value: "Saint-Théodore-d'Acton", label: "Saint-Théodore-d'Acton" },
  { value: "Saint-Thomas", label: "Saint-Thomas" },
  { value: "Saint-Thomas-Didyme", label: "Saint-Thomas-Didyme" },
  { value: "Saint-Thuribe", label: "Saint-Thuribe" },
  { value: "Saint-Tite", label: "Saint-Tite" },
  { value: "Saint-Tite-des-Caps", label: "Saint-Tite-des-Caps" },
  { value: "Saint-Ubalde", label: "Saint-Ubalde" },
  { value: "Saint-Ulric", label: "Saint-Ulric" },
  { value: "Saint-Urbain", label: "Saint-Urbain" },
  { value: "Saint-Urbain-Premier", label: "Saint-Urbain-Premier" },
  { value: "Saint-Valentin", label: "Saint-Valentin" },
  { value: "Saint-Valérien", label: "Saint-Valérien" },
  { value: "Saint-Valérien-de-Milton", label: "Saint-Valérien-de-Milton" },
  { value: "Saint-Vallier", label: "Saint-Vallier" },
  { value: "Saint-Vianney", label: "Saint-Vianney" },
  { value: "Saint-Victor", label: "Saint-Victor" },
  { value: "Saint-Wenceslas", label: "Saint-Wenceslas" },
  { value: "Saint-Zacharie", label: "Saint-Zacharie" },
  { value: "Saint-Zénon", label: "Saint-Zénon" },
  { value: "Saint-Zénon-du-Lac-Humqui", label: "Saint-Zénon-du-Lac-Humqui" },
  { value: "Saint-Zéphirin-de-Courval", label: "Saint-Zéphirin-de-Courval" },
  { value: "Saint-Zotique", label: "Saint-Zotique" },
  { value: "Salaberry-de-Valleyfield", label: "Salaberry-de-Valleyfield" },
  { value: "Salliuit", label: "Salliuit" },
  { value: "Scott", label: "Scott" },
  { value: "Scotstown", label: "Scotstown" },
  { value: "Senneterre", label: "Senneterre" },
  { value: "Sept-Îles", label: "Sept-Îles" },
  { value: "Senneville", label: "Senneville" },
  { value: "Shawville", label: "Shawville" },
  { value: "Sheenboro", label: "Sheenboro" },
  { value: "Sherbrooke", label: "Sherbrooke" },
  { value: "Shigawake", label: "Shigawake" },
  { value: "Sorel-Tracy", label: "Sorel-Tracy" },
  { value: "Stanbridge East", label: "Stanbridge East" },
  { value: "Stanbridge Station", label: "Stanbridge Station" },
  { value: "Stanstead", label: "Stanstead" },
  { value: "Stanstead-Est", label: "Stanstead-Est" },
  { value: "Stoke", label: "Stoke" },
  { value: "Stoneham-et-Tewkesbury", label: "Stoneham-et-Tewkesbury" },
  { value: "Stratford", label: "Stratford" },
  { value: "Stukely-Sud", label: "Stukely-Sud" },
  { value: "Sutton", label: "Sutton" },
  { value: "Tadoussac", label: "Tadoussac" },
  { value: "Taillon", label: "Taillon" },
  { value: "Taschereau", label: "Taschereau" },
  { value: "Témiscaming", label: "Témiscaming" },
  { value: "Témiscouata-sur-le-Lac", label: "Témiscouata-sur-le-Lac" },
  { value: "Terrebonne", label: "Terrebonne" },
  { value: "Thetford Mines", label: "Thetford Mines" },
  { value: "Thorne", label: "Thorne" },
  { value: "Thurso", label: "Thurso" },
  { value: "Timmins", label: "Timmins" },
  { value: "Tomifobia", label: "Tomifobia" },
  { value: "Tourville", label: "Tourville" },
  { value: "Très-Saint-Rédempteur", label: "Très-Saint-Rédempteur" },
  { value: "Très-Saint-Sacrement", label: "Très-Saint-Sacrement" },
  { value: "Tricot", label: "Tricot" },
  { value: "Trois-Pistoles", label: "Trois-Pistoles" },
  { value: "Trois-Rivières", label: "Trois-Rivières" },
  { value: "Trois-Rives", label: "Trois-Rives" },
  { value: "Tring-Jonction", label: "Tring-Jonction" },
  { value: "Uashat mak Mani-Utenam", label: "Uashat mak Mani-Utenam" },
  { value: "Umiujaq", label: "Umiujaq" },
  { value: "Val-Alain", label: "Val-Alain" },
  { value: "Val-Brillant", label: "Val-Brillant" },
  { value: "Val-d'Or", label: "Val-d'Or" },
  { value: "Val-des-Bois", label: "Val-des-Bois" },
  { value: "Val-des-Lacs", label: "Val-des-Lacs" },
  { value: "Val-des-Monts", label: "Val-des-Monts" },
  { value: "Val-Joli", label: "Val-Joli" },
  { value: "Val-Morin", label: "Val-Morin" },
  { value: "Val-Racine", label: "Val-Racine" },
  { value: "Val-Saint-Gilles", label: "Val-Saint-Gilles" },
  { value: "Valcourt", label: "Valcourt" },
  { value: "Vallée-Jonction", label: "Vallée-Jonction" },
  { value: "Varennes", label: "Varennes" },
  { value: "Vaudreuil-Dorion", label: "Vaudreuil-Dorion" },
  { value: "Vaudreuil-sur-le-Lac", label: "Vaudreuil-sur-le-Lac" },
  { value: "Venise-en-Québec", label: "Venise-en-Québec" },
  { value: "Verchères", label: "Verchères" },
  { value: "Victoriaville", label: "Victoriaville" },
  { value: "Ville-Marie", label: "Ville-Marie" },
  { value: "Vinton", label: "Vinton" },
  { value: "Waltham", label: "Waltham" },
  { value: "Warwick", label: "Warwick" },
  { value: "Waskaganish", label: "Waskaganish" },
  { value: "Waswanipi", label: "Waswanipi" },
  { value: "Waterloo", label: "Waterloo" },
  { value: "Waterville", label: "Waterville" },
  { value: "Weedon", label: "Weedon" },
  { value: "Weir", label: "Weir" },
  { value: "Wendake", label: "Wendake" },
  { value: "Westmount", label: "Westmount" },
  { value: "Wotton", label: "Wotton" },
  { value: "Yamachiche", label: "Yamachiche" },
  { value: "Yamaska", label: "Yamaska" },
];
